var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{staticClass:"pc-expansion-panels",attrs:{"flat":_vm.flat,"accordion":_vm.accordion,"multiple":_vm.multiple,"focusable":_vm.focusable,"hover":_vm.hover,"disabled":_vm.disabled,"readonly":_vm.readonly,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }